import React from 'react';
import PropTypes from 'prop-types';
import {
  PrimaryButton,
  SecondaryButton,
  OutlineButton,
  InfoButton,
  WhiteButton,
  LinkButton
} from '@tfecom-thermofisher/react-komodo-design';

import { icons } from 'src/constants';
import Message from '../Message';
import Icon from '../Icon';
import Visible from '../Visible';

import IconButton from './IconButton';
import TertiaryButton from './TertiaryButton';
import './styles.scss';

const getButtonComponentByType = (type) => {
  switch (type) {
    case 'primary': {
      return PrimaryButton;
    }
    case 'secondary': {
      return SecondaryButton;
    }
    case 'tertiary': {
      return TertiaryButton;
    }
    case 'outline': {
      return OutlineButton;
    }
    case 'info': {
      return InfoButton;
    }
    case 'link': {
      return LinkButton;
    }
    case 'white': {
      return WhiteButton;
    }
    default: {
      return null;
    }
  }
};

const Button = (props) => {
  const {
    type,
    iconName,
    iconPosition = 'left',
    iconSize,
    label,
    iconColor = 'blue',
    disabled,
    ...htmlButonProps
  } = props;

  if (type === 'icon') {
    return (
      <IconButton
        iconName={iconName}
        iconSize={iconSize}
        iconColor={iconColor}
        disabled={disabled}
        {...htmlButonProps}
      />
    );
  }

  const ButtonComponent = getButtonComponentByType(type);

  if (!ButtonComponent) {
    // if the type is invalid we have no component and we render nothing
    return null;
  }

  return (
    <ButtonComponent {...{ disabled, ...htmlButonProps }}>
      <Visible when={iconName && iconPosition === 'left'}>
        <Icon
          name={iconName}
          size={iconSize}
          color={iconColor}
          disabled={disabled}
        />
        <span className="button-left-icon-spacer" />
      </Visible>

      <Message message={label} />

      <Visible when={iconName && iconPosition === 'right'}>
        <span className="button-right-icon-spacer" />
        <Icon
          name={iconName}
          size={iconSize}
          color={iconColor}
          disabled={disabled}
        />
      </Visible>
    </ButtonComponent>
  );
};

Button.propTypes = {
  type: PropTypes.oneOf([
    'primary',
    'secondary',
    'tertiary',
    'outline',
    'info',
    'link',
    'white',
    'icon'
  ]),
  iconName: PropTypes.string,
  iconSize: PropTypes.oneOf(icons.ALLOWED_ICON_SIZES),
  label: PropTypes.shape({
    id: PropTypes.string,
    defaultMessage: PropTypes.string
  }),
  iconPosition: PropTypes.oneOf(['left', 'right']),
  iconColor: PropTypes.oneOf(icons.ALLOWED_ICON_COLORS),
  disabled: PropTypes.bool
};

export default Button;
